import { render, staticRenderFns } from "./Shift.vue?vue&type=template&id=dd0e07a4&scoped=true"
import script from "./Shift.vue?vue&type=script&lang=ts"
export * from "./Shift.vue?vue&type=script&lang=ts"
import style0 from "./Shift.vue?vue&type=style&index=0&id=dd0e07a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd0e07a4",
  null
  
)

export default component.exports